import i18n from '@/i18n';
import { NAMEROLEFIXED } from '@/config/constants';

function initForm() {
    return {
        name: '',
        kana_name: '',
        email: '',
        phone_number: '',
        password: '',
        team: null,
        status: 1,
        type: 1,
        role_id: null,
        note: '',
        account_id: null,
        chatwork_id: '',
        chatwork_token: '',
        phone_setting_type: []
    };
}

function configFormEmployee() {
    return {
        name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.name'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255']
        },

        phone_number: {
            isNumber: false,
            isConvertHalfsize: true,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.cellphoneNumber'),
            errorCustomMess: '',
            typesValidate: ['max20', 'number-hyphens']
        },

        kana_name: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.name_kana'),
            errorCustomMess: '',
            typesValidate: ['required', 'katakana', 'max255']
        },

        email: {
            autocomplete: 'new-email',
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.email'),
            errorCustomMess: '',
            typesValidate: ['required', 'max255', 'email']
        },

        password: {
            autocomplete: 'new-password',
            isNumber: false,
            isPassword: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.password'),
            errorCustomMess: '',
            type: 'password',
            typesValidate: ['required', 'max255', 'password']
        },

        role_id: {
            errorField: i18n.t('pageEmployee.role'),
            error: false,
            isRemove: false,
            messageCustom: true,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },

        team: {
            trackBy: 'id',
            label: 'value',
            errorField: i18n.t('pageEmployee.team'),
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: ['requiredSelect']
        },

        account_id: {
            isNumber: true,
            maxlength: 10,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.accountId'),
            errorCustomMess: '',
            typesValidate: ['max255']
        },

        chatwork_id: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.chatworkId'),
            errorCustomMess: '',
            typesValidate: ['max255']
        },

        chatwork_token: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('pageEmployee.tokenUser'),
            errorCustomMess: '',
            typesValidate: ['max255']
        }
    };
}

const ROLE_OPTIONS = [
    {
        id: 1,
        text: '社員'
    },
    {
        id: 2,
        text: i18n.t('part_time')
    }
];

const AUTHORITY_OPTIONS = [
    {
        id: NAMEROLEFIXED[0].id,
        text: i18n.t('administrator')
    },
    {
        id: NAMEROLEFIXED[1].id,
        text: i18n.t('sale_instructor')
    }
];

const STATUS_OPTIONS = [
    {
        id: 1,
        text: '有効'
    },
    {
        id: 0,
        text: '無効'
    }
];

export { initForm, ROLE_OPTIONS, AUTHORITY_OPTIONS, STATUS_OPTIONS, configFormEmployee };
